import { createFileRoute } from "@tanstack/react-router"
import { ForecastAlertThresholdCard } from "~/components/settings/ForecastAlertThresholdCard"

export const Route = createFileRoute("/_auth/settings/_layout/_internal/alerts")({
  component: ForecastAlertThresholdCard,
})
